import { FC, useMemo } from 'react';
import { ZoneTag } from 'src/components/ui/ZoneTag';
import { PolygonsFilterType } from 'src/config/types';
import { useAppSelector } from 'src/hooks/useRedux';

interface PurposesFilterProps {
  handleSelect: (id: number | string, filterName: keyof PolygonsFilterType) => void;
  tempFilter: PolygonsFilterType;
}

export const PurposesFilter: FC<PurposesFilterProps> = ({ handleSelect, tempFilter }) => {
  const { purposes } = useAppSelector(state => state.categories);

  const normalizedPurposes = useMemo(
    () =>
      purposes?.map((purpose: string, index: number) => ({
        id: purpose,
        name: purpose,
      })) ?? [],
    [purposes],
  );

  return (
    <div className="flex flex-wrap gap-2">
      {normalizedPurposes.map(purpose => (
        <ZoneTag
          key={`purposes-filter-${purpose.id}`}
          fullWidth
          onClick={() => handleSelect(purpose.id, 'purposes')}
          //TODO: fix types in purposes
          //@ts-ignore
          isActive={tempFilter?.purposes?.includes(purpose.id)}
          //TODO: fix types in purposes
          //@ts-ignore
          category={purpose}
        />
      ))}
    </div>
  );
};
